export default "__VITE_ASSET__B9klTAT6__"